
function Footer() {
  return (
    <>
      <footer className="footer footer-center p-4 bg-base-300 text-base-content">
        <aside>
          <p>Made by <a href="https://lonyinchan.com">Lonyin Chan</a> 2024</p>
        </aside>
      </footer>
    </>
  );
}

export default Footer;